const homepageViewerImageBaseUrl = '/images/phone'

/**
 * These frames are deployed with the site. Load them from the same origin so
 * the homepage does not depend on Gumlet availability or cross-origin image
 * loading. Keep resizing disabled to preserve the original frame requests.
 */
export const homepageViewerImageConfig = {
  initialImageUrl: `${homepageViewerImageBaseUrl}/iphone-gold-01.png`,
  imageUrlFormat: 'iphone-gold-xx.png',
  autoCDNResizer: false,
} as const
